var map = {
	"./01.jpg": "0a77",
	"./02.jpg": "9b2b",
	"./03.jpg": "18ff",
	"./04.jpg": "80d9",
	"./05.jpg": "eab6",
	"./06.jpg": "7518",
	"./07.jpg": "9e0c",
	"./08.jpg": "aada",
	"./09.jpg": "1317",
	"./10.jpg": "3270"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8098";